// Reset démo (LOT 7c §5) — wrapper ADDITIF du data layer (fichiers gelés §6 :
// 0 diff). Efface TOUT l'état local : base Dexie entière (`db.delete()`) +
// purge des clés `localStorage` préfixées `tablier:` (tenantId, marqueurs
// seed…). Rouvre ensuite une base NEUVE (même nom) pour produire le bilan
// « toutes tables = 0 » affiché avant reload. Réservé à la route non liée
// #/reset-demo — jamais appelé par l'UI de service.
import { TablierDb, closeDb, getDb, setDb } from './index';

export const PREFIXE_TABLIER = 'tablier:';

export interface ResetDemoBilan {
  /** Compte par table APRÈS reset (attendu : tout à 0). */
  tables: Record<string, number>;
  /** Nombre de clés localStorage `tablier:*` purgées. */
  clesPurgees: number;
}

export async function resetDemo(): Promise<ResetDemoBilan> {
  const courante = getDb();
  const nom = courante.name;

  // 1) Suppression de la base entière (ferme la connexion).
  await courante.delete();
  await closeDb();

  // 2) Purge localStorage tablier:* (tenantId, seedVersion, …).
  let clesPurgees = 0;
  if (typeof globalThis.localStorage !== 'undefined') {
    const aPurger: string[] = [];
    for (let i = 0; i < globalThis.localStorage.length; i++) {
      const cle = globalThis.localStorage.key(i);
      if (cle !== null && cle.startsWith(PREFIXE_TABLIER)) aPurger.push(cle);
    }
    for (const cle of aPurger) {
      globalThis.localStorage.removeItem(cle);
      clesPurgees++;
    }
  }

  // 3) Base neuve (même nom) + bilan toutes tables à 0.
  const neuve = new TablierDb(nom);
  await neuve.open();
  setDb(neuve);
  const tables: Record<string, number> = {};
  for (const table of neuve.tables) {
    tables[table.name] = await table.count();
  }
  return { tables, clesPurgees };
}
